import { authService } from '../services/authService'

export const authConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  LOGOUT: 'USERS_LOGOUT',
}

export const authActions = {
  checkHash
}

function request() {
  return { type: authConstants.LOGIN_REQUEST }
}
function success(player) {
  return { type: authConstants.LOGIN_SUCCESS, payload: player }
}
function failure(error) {
  return { type: authConstants.LOGIN_FAILURE, payload: error }
}

function checkHash(hash, errorMessage) {
  return (dispatch) => {
    dispatch(request({ hash }))

    authService.checkHash(hash).then(
      (res) => {
        const player = {
          player: res.PROFILE,
          hash: hash
        }
        dispatch(success(player))
      },
      (error) => {
        errorMessage('Não conseguiu encontrar o jogador')
        dispatch(failure(error))
      },
    )
  }
}
